module.exports = __webpack_public_path__ + "static/media/spradling-logo-landscape.c824821d.svg";